var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "选择部门",
        width: _vm.modalWidth,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: "关闭",
      },
      on: { ok: _vm.handleSubmit, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { tip: "Loading...", spinning: false } },
        [
          _c("a-input-search", {
            staticStyle: { "margin-bottom": "1px" },
            attrs: { placeholder: "请输入部门名称按回车进行搜索" },
            on: { search: _vm.onSearch },
          }),
          _c("a-tree", {
            attrs: {
              checkable: "",
              treeData: _vm.treeData,
              checkStrictly: true,
              autoExpandParent: _vm.autoExpandParent,
              expandedKeys: _vm.expandedKeys,
              checkedKeys: _vm.checkedKeys,
            },
            on: {
              check: _vm.onCheck,
              select: _vm.onSelect,
              expand: _vm.onExpand,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function ({ title }) {
                  return [
                    title.indexOf(_vm.searchValue) > -1
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                title.substr(0, title.indexOf(_vm.searchValue))
                              ) +
                              "\n          "
                          ),
                          _c("span", { staticStyle: { color: "#f50" } }, [
                            _vm._v(_vm._s(_vm.searchValue)),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                title.substr(
                                  title.indexOf(_vm.searchValue) +
                                    _vm.searchValue.length
                                )
                              ) +
                              "\n        "
                          ),
                        ])
                      : _c("span", [_vm._v(_vm._s(title))]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }